import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import footer from './Footer.module.css';


function Footer() {
    return (
        <div>
            <div id={footer.title}>
                <p className="font_playfair_22">
                    Fans &amp; Feathers
                </p>
            </div>
            <div id={footer.email}>
                <p className="font_raleway_15">
                    <a style={{ color: "inherit", "textDecoration": "none" }} href="mailto:info@fansandfeathers.com">info@fansandfeathers.com</a>
                </p>
            </div>
            <div id={footer.copyright}>
                <p className="font_raleway_14">                    
                    <Container fluid>
                        <Row>
                            <Col xs={12} md={6}>
                                ©2026 Phoenix Object Conservation
                            </Col>                            
                            <Col xs={12} md={6}>
                                Website by Wildfire Software
                            </Col>
                        </Row>
                    </Container>
                </p>
            </div>
        </div>
    );
}

export default Footer;